export const USER = '[User]'

export const CREATE_USER = `${USER} CREATE_USER`
export const GET_USERS = `${USER} GET_USERS`
export const SET_USERS = `${USER} SET_USERS`
